/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addBankAccount } from '../fn/payment-method-api/add-bank-account';
import { AddBankAccount$Params } from '../fn/payment-method-api/add-bank-account';
import { ApiResponseBankAccountRibDto } from '../models/api-response-bank-account-rib-dto';
import { ApiResponseListBankAccountRibDto } from '../models/api-response-list-bank-account-rib-dto';
import { ApiResponseListPaymentMethodDto } from '../models/api-response-list-payment-method-dto';
import { ApiResponsePaymentMethodDto } from '../models/api-response-payment-method-dto';
import { ApiResponseVoid } from '../models/api-response-void';
import { createPaymentMethod } from '../fn/payment-method-api/create-payment-method';
import { CreatePaymentMethod$Params } from '../fn/payment-method-api/create-payment-method';
import { deleteBankAccount } from '../fn/payment-method-api/delete-bank-account';
import { DeleteBankAccount$Params } from '../fn/payment-method-api/delete-bank-account';
import { deletePaymentMethod } from '../fn/payment-method-api/delete-payment-method';
import { DeletePaymentMethod$Params } from '../fn/payment-method-api/delete-payment-method';
import { getAvailablePaymentMethods } from '../fn/payment-method-api/get-available-payment-methods';
import { GetAvailablePaymentMethods$Params } from '../fn/payment-method-api/get-available-payment-methods';
import { getBankAccountsByMethod } from '../fn/payment-method-api/get-bank-accounts-by-method';
import { GetBankAccountsByMethod$Params } from '../fn/payment-method-api/get-bank-accounts-by-method';
import { getPaymentMethodByReference } from '../fn/payment-method-api/get-payment-method-by-reference';
import { GetPaymentMethodByReference$Params } from '../fn/payment-method-api/get-payment-method-by-reference';
import { updatePaymentMethod } from '../fn/payment-method-api/update-payment-method';
import { UpdatePaymentMethod$Params } from '../fn/payment-method-api/update-payment-method';

@Injectable({ providedIn: 'root' })
export class PaymentMethodApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPaymentMethodByReference()` */
  static readonly GetPaymentMethodByReferencePath = '/v1/api/payment-methods/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaymentMethodByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentMethodByReference$Response(params: GetPaymentMethodByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePaymentMethodDto>> {
    return getPaymentMethodByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaymentMethodByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentMethodByReference(params: GetPaymentMethodByReference$Params, context?: HttpContext): Observable<ApiResponsePaymentMethodDto> {
    return this.getPaymentMethodByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePaymentMethodDto>): ApiResponsePaymentMethodDto => r.body)
    );
  }

  /** Path part for operation `updatePaymentMethod()` */
  static readonly UpdatePaymentMethodPath = '/v1/api/payment-methods/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePaymentMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaymentMethod$Response(params: UpdatePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePaymentMethodDto>> {
    return updatePaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePaymentMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaymentMethod(params: UpdatePaymentMethod$Params, context?: HttpContext): Observable<ApiResponsePaymentMethodDto> {
    return this.updatePaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePaymentMethodDto>): ApiResponsePaymentMethodDto => r.body)
    );
  }

  /** Path part for operation `deletePaymentMethod()` */
  static readonly DeletePaymentMethodPath = '/v1/api/payment-methods/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePaymentMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePaymentMethod$Response(params: DeletePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return deletePaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePaymentMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePaymentMethod(params: DeletePaymentMethod$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.deletePaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `createPaymentMethod()` */
  static readonly CreatePaymentMethodPath = '/v1/api/payment-methods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPaymentMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPaymentMethod$Response(params: CreatePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePaymentMethodDto>> {
    return createPaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPaymentMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPaymentMethod(params: CreatePaymentMethod$Params, context?: HttpContext): Observable<ApiResponsePaymentMethodDto> {
    return this.createPaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePaymentMethodDto>): ApiResponsePaymentMethodDto => r.body)
    );
  }

  /** Path part for operation `getBankAccountsByMethod()` */
  static readonly GetBankAccountsByMethodPath = '/v1/api/payment-methods/{methodReference}/bank-accounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBankAccountsByMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBankAccountsByMethod$Response(params: GetBankAccountsByMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListBankAccountRibDto>> {
    return getBankAccountsByMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBankAccountsByMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBankAccountsByMethod(params: GetBankAccountsByMethod$Params, context?: HttpContext): Observable<ApiResponseListBankAccountRibDto> {
    return this.getBankAccountsByMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListBankAccountRibDto>): ApiResponseListBankAccountRibDto => r.body)
    );
  }

  /** Path part for operation `addBankAccount()` */
  static readonly AddBankAccountPath = '/v1/api/payment-methods/{methodReference}/bank-accounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addBankAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBankAccount$Response(params: AddBankAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBankAccountRibDto>> {
    return addBankAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addBankAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBankAccount(params: AddBankAccount$Params, context?: HttpContext): Observable<ApiResponseBankAccountRibDto> {
    return this.addBankAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBankAccountRibDto>): ApiResponseBankAccountRibDto => r.body)
    );
  }

  /** Path part for operation `getAvailablePaymentMethods()` */
  static readonly GetAvailablePaymentMethodsPath = '/v1/api/payment-methods/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailablePaymentMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailablePaymentMethods$Response(params: GetAvailablePaymentMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPaymentMethodDto>> {
    return getAvailablePaymentMethods(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailablePaymentMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailablePaymentMethods(params: GetAvailablePaymentMethods$Params, context?: HttpContext): Observable<ApiResponseListPaymentMethodDto> {
    return this.getAvailablePaymentMethods$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListPaymentMethodDto>): ApiResponseListPaymentMethodDto => r.body)
    );
  }

  /** Path part for operation `deleteBankAccount()` */
  static readonly DeleteBankAccountPath = '/v1/api/payment-methods/{methodReference}/bank-accounts/{accountReference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBankAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBankAccount$Response(params: DeleteBankAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return deleteBankAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBankAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBankAccount(params: DeleteBankAccount$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.deleteBankAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

}
